// src/utils/time.ts

export function timeAgo(date: Date): string {

    const now = new Date();
  
    // Compute the difference in milliseconds
    const diff = now.getTime() - date.getTime();
  
    // Define time intervals in milliseconds
    const seconds = 1000;
    const minute = 60 * seconds;
    const hour = 60 * minute;
    const day = 24 * hour;
    const week = 7 * day;
    const month = 30 * day;
    const year = 365 * day;
  
    // Calculate the time ago based on the difference
    if (diff < minute) {
      const secondsAgo = Math.floor(diff / seconds);
      return `${secondsAgo} second${secondsAgo !== 1 ? 's' : ''} ago`;
    } else if (diff < hour) {
      const minutesAgo = Math.floor(diff / minute);
      return `${minutesAgo} minute${minutesAgo !== 1 ? 's' : ''} ago`;
    } else if (diff < day) {
      const hoursAgo = Math.floor(diff / hour);
      return `${hoursAgo} hour${hoursAgo !== 1 ? 's' : ''} ago`;
    } else if (diff < 2 * week) {
      const daysAgo = Math.floor(diff / day);
      return `${daysAgo} day${daysAgo !== 1 ? 's' : ''} ago`;
    } else if (diff < month) {
      const weeksAgo = Math.floor(diff / week);
      return `${weeksAgo} week${weeksAgo !== 1 ? 's' : ''} ago`;
    } else if (diff < year) {
      const monthsAgo = Math.floor(diff / month);
      return `${monthsAgo} month${monthsAgo !== 1 ? 's' : ''} ago`;
    } else {
      const yearsAgo = Math.floor(diff / year);
      return `${yearsAgo} year${yearsAgo !== 1 ? 's' : ''} ago`;
    }
  }
